import { render, staticRenderFns } from "./modalAnadirCedis.vue?vue&type=template&id=067949a6&"
import script from "./modalAnadirCedis.vue?vue&type=script&lang=js&"
export * from "./modalAnadirCedis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports